export const API = {
    USER: '/user',
    RESULT: '/lotte/cities',
    CATEGORIES: '/lotte/categories',
    START_DATE: '/lotte/startdate',
    CITIES: '/lotte/cities',
    RELEASE: '/lotte/release',
    HISTORY: '/user/history',
    ORDER: '/lotte/order',
    KQSX_RESULT: '/lotte/results',
    LAST_DATE: '/lotte/lastdate',
    RATES: '/rates',
};
